<template>
<v-layout wrap>
  <v-flex xs12>
    <v-card full-width class='mx-3'>
      <v-card-title class="title" >
        Merge clients
        <v-spacer />
        <v-icon>merge_type</v-icon>
        <!-- <v-btn outline >Learn more
          <v-icon small class='ml-2' >open_in_new</v-icon>
        </v-btn> -->
      </v-card-title>
      <!-- <v-breadcrumbs :items="crumbs"></v-breadcrumbs> -->
      <v-alert :value='true' type='info' dismissible >

        <h3 class='subheading '>Before you start:</h3>
        <li>Merging should be performed by a <strong>practice owner</strong></li>
        <li>If you are marging clients owned by a different practitioner, make sure they have <strong>shared them with a space that you own</strong></li>

        <h3 class='subheading mt-2' >How it works:</h3>
        <li>Select two clients. One that you would like to keep, and one that you would like to remove.</li>
        <li>We'll load all the information for each client</li>
        <li>Read through the information and transfer relevant information from the client you woud like to delete to the client that you are keeping</li>
        <li>Once you've moved all the information, you can safely delete the empty client</li>
      </v-alert>
      <v-layout >
        <v-flex xs5 >
          <v-card class='ma-4' >
            <v-card-title class='subtitle-1 overline' >
              1./ The client that you would like to <strong class='ml-1' >keep</strong>
            </v-card-title>
            <relationship-picker class='mx-2'
              :multiple='false'
              @selected='setLeft' >
            </relationship-picker>
            <v-divider></v-divider>
            <client-list-item
              show-spaces with-details
              v-model='relationshipId'
              :owner='left.practitioner_id'
              :spaces='left.spaces'
              :with-action='false'
              v-if='left && left.id'
              :relationship-id='left.id'
              :client='left' >
              <v-chip class="v-chip--x-small" outline label slot='after-title'>#{{left.id}}</v-chip>
            </client-list-item>
            <!-- <pre v-text='left' /> -->
           </v-card>
        </v-flex>
        <v-flex xs2 class='text-center pt-5' >
          <center>
            <v-btn
              @click='swap(left, right)'
              flat :disabled='!left || !right' >
              <v-icon>chevron_left</v-icon>
              swap
              <v-icon>chevron_right</v-icon>
            </v-btn>
          </center>
        </v-flex>
        <v-flex xs5 >
          <v-card class='ma-4' >
            <v-card-title class='subtitle-1 overline' >
              2./ The client that you would like to <strong class='ml-1' >remove</strong>
            </v-card-title>
            <relationship-picker class='mx-2' :multiple='false'
              @input='requests.delete.status=0'
              @selected='setRight' >
            </relationship-picker >
            <v-divider></v-divider>
            <client-list-item
              v-if='right && right.id'
              show-spaces with-details
              :owner='right.practitioner_id'
              :spaces='right.spaces'
              :with-action='false'
              :relationship-id='right.id'
              :client='right' >
              <v-chip class="v-chip--x-small" outline label slot='after-title'>#{{right.id}}</v-chip>
            </client-list-item>
            <v-alert class='ma-0' tile dismissible
              v-if='deleteRequestStatus===204'
              :value='true'
              type='success' >
              Client has successfully been removed
            </v-alert>
          </v-card>
        </v-flex>
      </v-layout>
      <v-card-actions >
        <span v-if='left && right && (left.id === right.id)'
          class='ml-3 red--text' >
          <v-icon small color='error' >warning</v-icon>
          these are the same users
        </span>
        <v-spacer />
        <v-btn @click='compare'
          :loading='comparisonRequest.loading'
          :disabled='!canCompare' class='mr-3' color='primary' >Compare</v-btn>
      </v-card-actions>
      <request-status
        :request="comparisonRequest"
        message403="You do not have the required permissions for one of these users. Please ensure that you are the owner of both clients, or that the client is shared in a space which you own" />
    </v-card>
  </v-flex>

  <v-flex xs12 v-if='right && leftDetail && rightDetail && !isDirty' >

    <v-card class='mt-3 pb-5 mx-3' >
       <v-card-title class='subtitle-1 overline' >
        Merge options:
      </v-card-title>
      <v-card-text color='gray lighten-4' >

        <v-divider></v-divider>
        <template v-if='leftRecord && rightRecord' >

          <object-selector with-edit
            class='mt-3'
            title='Choose details'
            same-title='Details are the same'
            v-model='merge.record'
            @edit="launchCustomerDetailsDialog(left.id)"
            :left='leftRecord'
            :right='rightRecord'
            :display-component='recordComponent'
            :display-component-left-attrs="{value: leftRecord}"
            :display-component-right-attrs="{value: rightRecord}" >
            <v-alert :value='true' slot='alert' type='info' >
              We will keep the record on the left. You can edit it if values on the right are more recent
            </v-alert>
          </object-selector>

        </template>
      </v-card-text>
      <!-- owner-->
    </v-card>

    <!-- <v-card class='mt-3 pb-5' >
      <v-card-title class='overline' >
        Related Items
      </v-card-title>

      <v-alert :value='true' type='info' >
        Choose the items you would like to transfer from the right to the left.
      </v-alert>

    <v-card class='elevation-4 ma-3' v-if='left && right' >
      <v-card-title class='subtitle-1 overline' >Spaces</v-card-title>
      <v-divider/>
      <v-layout >
        <v-flex xs6 >
          <space-faces class='ma-2' v-if='left && left.spaces' :space-ids='left.spaces' >
          </space-faces>
        </v-flex>
        <v-divider vertical />
        <v-flex xs6 >
          <space-faces class='ma-2' v-if='right && right.spaces' :space-ids='right.spaces' >
          </space-faces>
        </v-flex>
      </v-layout>
    </v-card> -->

    <!-- appts -->
    <template v-if='rightDetail && rightDetail.appointments && leftDetail && leftDetail.appointments' >
      <array-merge-preview
        class='ma-3'
        title='Appointments'
        :loading='requests.transfer.appts.loading || comparisonRequest.loading'
        :left='leftDetail.appointments'
        :right='rightDetail.appointments'
        item-title='title'
        item-sub-title='start_time'
        @transfer='transferAppts' >
      </array-merge-preview>
    </template>

    <!-- notes -->
    <template v-if='rightDetail && rightDetail.notes && leftDetail && leftDetail.notes' >
      <array-merge-preview class='ma-3'
        title='notes'
        :loading='requests.transfer.notes.loading || comparisonRequest.loading'
        :left='leftDetail.notes'
        :right='rightDetail.notes'
        item-title='title'
        item-sub-title='start_time'
        @transfer='transferNotes' >
        <v-alert type='info' :value='true' class='ma-0' tile >
          We can only show you notes to which you have access.
          Please ensure that any team members
          who may have have created notes
          has shared them with an appropriate space
        </v-alert>
      </array-merge-preview>
    </template>

    <template v-if='rightDetail && rightDetail.invoices && rightDetail.invoices.results && leftDetail && leftDetail.invoices && leftDetail.invoices.results' >
      <array-merge-preview class='ma-3'
        title='invoices'
        :loading='requests.transfer.invs.loading || comparisonRequest.loading'
        :left='leftDetail.invoices.results'
        :right='rightDetail.invoices.results'
        @transfer='transferInvoices'
        item-title='title'
        item-sub-title='start_time' >
      </array-merge-preview>
    </template>

    <!-- <template v-if='rightDetail && rightDetail.appointments && leftDetail && leftDetail.appointments' >
      <array-merge-preview class='ma-3'
        title='Appointments'
        :left='leftDetail.appointments'
        :right='rightDetail.appointments'
        item-title='title'
        item-sub-title='start_time' >
      </array-merge-preview>
    </template> -->
    </v-card>

    <v-card class='mt-3' >
      <request-status :request='requests.delete' />
      <v-card-actions v-if='right && right.id' >
        <v-spacer></v-spacer>
        <v-btn
          :loading='requests.delete.loading'
          @click='archive(right.id)' color='warning' >Archive right hand user</v-btn>
      </v-card-actions>
    </v-card>

    <!-- <v-card class='mt-3' >
      <pre>{{leftDetail}}</pre>
    </v-card> -->
  </v-flex>
</v-layout>
</template>
<script>
import ObjectSelector from './ObjectSelector'
import ArrayMergePreview from './ArrayMergePreview'
import RelationshipPicker from '@/components/pickers/RelationshipPicker'
import RecordCard from '@/components/cards/RecordCard'
import SpaceFaces from '@/components/lists/SpaceFaces'
import ClientListItem from '@/components/client/ClientListItem.vue'
import ShareForm from '@/components/client/forms/ShareForm.vue'
// import PatientInformationForm from '@/components/medicalaid/PatientInformationForm'

export default {
  name: 'MergeClients',
  components: {
    ObjectSelector,
    ArrayMergePreview,
    RelationshipPicker,
    SpaceFaces,
    RecordCard,
    ClientListItem,
    ShareForm
    // PatientInformationForm
  },
  props: {
    relationshipId: { required: false }
  },
  data () {
    return {
      left: null,
      right: null,
      reqId: 'get-comparison-req',
      merge: {
        owner: {},
        record: null,
        client: null
      },
      adminoverride: {
        leftId: null,
        rightId: null
      },
      crumbs: [
        {
          text: 'Clients',
          disabled: false,
          to: '/clients',
          exact: true
        }
      ],
      requests: {
        delete: {
          resource: 'ag.clients'
        },
        transfer: {
          appts: {
            resource: 'ag.practitioner.appointments',
            extra: 'actions/bulk_transfer_appointments'
          },
          notes: {
            resource: 'metadataguru.notes',
            extra: 'actions/transfer_client'
          },
          invs: {
            resource: 'invoiceguru.invoices',
            extra: 'transfer_invoices'
          }
        }
      },
      isDirty: true,
      personComponent: ClientListItem,
      recordComponent: RecordCard
    }
  },
  computed: {
    clientdiff () {
      return this.getObjectPath(this.comparisonRequest, 'result.data.diff', {})
    },
    leftDetail () {
      return this.getObjectPath(this.comparisonRequest, 'result.data.r1', {})
    },
    rightDetail () {
      return this.getObjectPath(this.comparisonRequest, 'result.data.r2', {})
    },
    leftRecord () {
      if (this.leftDetail && this.leftDetail.record && this.leftDetail.record.length === 2) {
        return this.leftDetail.record[0]
      }
    },
    rightRecord () {
      if (this.rightDetail && this.rightDetail.record && this.rightDetail.record.length === 2) {
        return this.rightDetail.record[0]
      }
    },
    leftRightString () {
      let str = ''
      if (this.left) { str += this.left.id }
      if (this.right) { str += this.right.id }
      return str
    },
    comparisonRequest () {
      return this.$store.getters.getRequestById(this.reqId, true)
    },
    comparisonRequestStatus () {
      return this.comparisonRequest.status
    },
    deleteRequestStatus () {
      return this.requests.delete.status
    },
    comparisonParams () {
      if (this.left && this.right) {
        let params = {
          'r1': this.left.id,
          'r2': this.right.id
        }
        return params
      }
    },
    canCompare () {
      if (this.adminoverride.leftId && this.adminoverride.rightId) { return true }
      if (!this.left || !this.right) { return false }
      if (this.left.id === this.right.id) { return false }
      return true
    },
    allTransferReqs () {
      return [
        this.requests.transfer.appts.status,
        this.requests.transfer.notes.status,
        this.requests.transfer.invs.status
      ]
    }
  },
  watch: {
    leftRightString () {
      this.isDirty = true
    },
    comparisonRequestStatus () {
      if (this.comparisonRequestStatus === 200) {
        this.isDirty = false
      }
    },
    allTransferReqs () {
      if (this.allTransferReqs.indexOf(200) !== -1) {
        this.compare()
      }
    },
    deleteRequestStatus () {
      if (this.deleteRequestStatus === 204) {
        // this.left = null
        this.right = null
      }
    }
  },
  methods: {
    setLeft (client) {
      this.left = client
    },
    setRight (client) {
      this.right = client
    },
    startMerge () {
    },
    swap (left, right) {
      let lcopy = JSON.parse(JSON.stringify(left))
      let rcopy = JSON.parse(JSON.stringify(right))
      this.left = rcopy
      this.right = lcopy
      this.compare()
    },
    transferInvoices (selected) {
      this.requests.transfer.invs.data = {
        invoices: selected.join(','),
        transfer_to_relationship: this.left.id
      }
      this.$request('save', this.requests.transfer.invs)
    },
    transferAppts (selected) {
      this.requests.transfer.appts.data = {
        appointments: selected.join(','),
        transfer_to_relationship: this.left.id
      }
      this.$request('save', this.requests.transfer.appts)
    },
    transferNotes (selected) {
      this.requests.transfer.notes.data = {
        notes: selected.join(','),
        transfer_to_relationship: this.left.id
      }
      this.$request('save', this.requests.transfer.notes)
    },
    archive (relationshipId) {
      this.requests.delete.resourceId = relationshipId
      this.$request('delete', this.requests.delete)
    },
    compare () {
      let params = null
      if (this.left && this.right) {
        params = {
          r1: this.left.id,
          r2: this.right.id
        }
      }
      if (this.adminoverride.leftId && this.adminoverride.rightId) {
        params = {
          r1: this.adminoverride.leftId,
          r2: this.adminoverride.rightId
        }
      }
      if (params) {
        this.$appointmentguru
          .resource('client.v2.compare')
          .id(this.reqId)
          .list(params)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?8f312978